import styled from "styled-components";

const StyledFloatingContainer = styled.div`
  position: fixed;
  z-index: 10;
  right: 32px;
  display: grid;
  justify-items: end;
  bottom: 16px;
`;

export function FloatingContainer(props) {
  return <StyledFloatingContainer>{props.children}</StyledFloatingContainer>;
}
